module.exports = __webpack_public_path__ + "img/index-manual-step-yellow-5@3x.e523c50c.png";